import { useState } from "react";
import { useUser } from "../../context/userContext";
import { updateUserPassword } from "../../api/userApi";

export function UpdatePasswordForm() {
    const { user } = useUser();
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");

    const updatePassword = async () => {
        if (newPassword !== confirmNewPassword) {
            alert("New passwords do not match.");
            return;
        }

        try {
            const response = await updateUserPassword(user.userId, currentPassword, newPassword);

            if (response.status === 200) {
                alert("Password updated successfully.");
                setCurrentPassword("");
                setNewPassword("");
                setConfirmNewPassword("");
            }
            else {
                alert("Failed to update password. Please check your current password.");
            }
        }
        catch (error) {
            console.error("Error updating password:", error);
            alert("An error occurred while updating the password. Please try again.");
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        updatePassword();
    }

    return (
        <div className="update-password-form-container">
            <form className="update-password-form" onSubmit={handleSubmit}>
                <div className="update-password-form-content">
                    <h3 className="update-password-form-title">Update Password</h3>
                    <div className="form-group mt-3">
                        <label>Current Password</label>
                        <input
                            type="password"
                            className="form-control mt-1"
                            placeholder="Enter current password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                        />
                    </div>
                    <div className="form-group mt-3">
                        <label>New Password</label>
                        <input
                            type="password"
                            className="form-control mt-1"
                            placeholder="Enter new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </div>
                    <div className="form-group mt-3">
                        <label>Confirm New Password</label>
                        <input
                            type="password"
                            className="form-control mt-1"
                            placeholder="Confirm new password"
                            value={confirmNewPassword}
                            onChange={(e) => setConfirmNewPassword(e.target.value)}
                        />
                    </div>
                    <div className="form-group mt-3 d-grid gap-2 d-md-flex justify-content-md-end">
                        <button type="submit" className="btn btn-primary">Update Password</button>
                    </div>
                </div>
            </form>
        </div>
    );
}
